import { useCallback } from "react";

import { scanAccept, scanRefuse, scanWarn } from "@/lib/scanFeedback";

// The floor's flash is now THE app-wide scan answer (lib/scanFeedback.jsx) — sound, tint and
// haptic in one place, mounted once by <ScanFeedbackHost /> in App.js. This hook stays so the floor
// screens read the same as before; FlashOverlay is nothing to render any more because the host
// already owns the overlay on every screen.
export function useFlash() {
  const trigger = useCallback((tone, message) => {
    if (tone === "success") scanAccept(message);
    else if (tone === "warning") scanWarn(message);
    else scanRefuse(message);
  }, []);
  return { trigger, FlashOverlay: null };
}
